import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
    icon: any;
    count: number | string;
    translate: string;
};

export function CommunityCardInfosDetails({ icon, count, translate }: Props) {
    const { t } = useTranslation();

    if (!count || count === 0) return null;

    return (
        <div className="flex gap-1 items-center">
            <img src={icon} alt={"house icon"} className={"w-[19px] h-[19px]"} />
            <div className={"whitespace-nowrap"}>
                {typeof count === "number" ? (
                    <>
                        {count} {t(translate)}
                    </>
                ) : (
                    <>
                        {t(translate)} {count}
                    </>
                )}
            </div>
        </div>
    );
}
